const addCommas = (number: any) => {
  const formatter = new Intl.NumberFormat("en-US");
  return formatter.format(number);
};
const normaliseDollar = (value: any, previousValue: any) => {
  if (!value) {
    return value;
  }
  const onlyNums = value.replace(/[^\d]/g, "");
  if (value === "$") {
    return "";
  } else if (value.length > 0) {
    return "$" + addCommas(onlyNums);
  }
};

export default normaliseDollar;
